<template>
  <div :class="['YellowDotDemo', { active: isVisible }]">
    <h5><SplittingText :outDirection="2" :text="instructionCopy" ref="SplittingText" /></h5>
    <div class="dotDemo">
      <div class="dots">
        <div class="dot_wrong" ref="dot_wrong_left">
          <img ref="dot_left" src="@/assets/images/dot_white.png" alt="">
          <svg class="cross" ref="cross_left" viewBox="0 0 40 40">
            <path class="crossPath" ref="cross_left_path" fill="none" d="M 10,10 L 30,30 M 30,10 L 10,30" />
          </svg>
        </div>
        <div class="dot_center">
          <div ref="dot_trigger">
            <LottieWrapper :options="getOptions.triggerIcon" :size="size.triggerIcon" ref="Lottie_TriggerIcon" :completeHandler="null" />
          </div>
          <img ref="dot_ring" src="@/assets/images/dot_ring.png" alt="">
        </div>
        <div class="dot_wrong" ref="dot_wrong_right">
          <img ref="dot_right" src="@/assets/images/dot_yellow.png" alt="">
          <svg class="cross" ref="cross_right" viewBox="0 0 40 40">
            <path class="crossPath" ref="cross_right_path" fill="none" d="M 10,10 L 30,30 M 30,10 L 10,30" />
          </svg>
        </div>
      </div>
    </div>
    <ContinueButton v-if="shouldShowContinueButton" :onUserActivity="onUserActivity" :onClick="proceed" ref="ContinueButton" :copy="continueButtonCopy" state="continue" />
  </div>
</template>

<script>

import LottieWrapper from '@/components/LottieWrapper'
import SplittingText from '@/components/SplittingText'
import ContinueButton from '@/components/ContinueButton'

// import * as animationDataTriggerIcon from '@/assets/svgs/Spacebar.json'
// import * as animationDataMobileIcon from '@/assets/svgs/MobileIcon.json';
import { SVGS } from '@/assets/svgs/locale_map'

import { TimelineLite, Expo, TweenLite } from 'gsap'

export default {
  name: 'YellowDotDemo',
  props: {
    onDemoComplete: Function,
    onUserActivity: Function,
    showGetReady: Function
  },
  components: {
    SplittingText,
    LottieWrapper,
    ContinueButton
  },
  data() {
    return {
      game: this.$store.state.game,
      size: {
        triggerIcon: {
          width: 300,
          height: 300
        }
      },
      showContinue: false
    }
  },
  watch: {
    shouldShowContinueButton: function( newVal, oldVal) {
      if ( newVal ) {

        setTimeout(() => {

          this.$refs.ContinueButton.animateElementsIn.play()

        }, 10 )

      }

    }
  },
  mounted() {
    this.initIdleStates()
    this.createAnimationTimeline()
  },
  beforeDestroy() {
  },
  computed: {
    locale() { return this.$store.state.lang },
    shouldShowContinueButton() { return this.showContinue },
    isVisible() { return !this.$store.state.ui.isCountdownVisible },
    isMobile() { return this.$store.state.isMobile },
    getOptions() {
      const { Phone, Spacebar } = SVGS[ this.locale.LOCALE ]
      return {
        triggerIcon: {
          animationData: this.isMobile ? Phone.default : Spacebar.default,
          autoplay: true,
          loop: true
        },
      }
    },
    continueButtonCopy() {
      return this.isMobile ? this.locale.TRIGGER_CONTINUE_MOBILE : this.locale.TRIGGER_CONTINUE
    },
    instructionCopy() {
      return this.isMobile ? this.locale.TUTORIAL_MOBILE : this.locale.TUTORIAL_DESKTOP
    }
  },
  methods: {
    initIdleStates() {
      const { dot_left, dot_trigger, dot_ring, dot_right } = this.$refs

      TweenLite.to( dot_left, 0, { opacity: 0, scale: 0 } )
      TweenLite.to( dot_right, 0, { opacity: 0, scale: 0 } )
      TweenLite.to( dot_ring, 0, { opacity: 0, scale: 0 } )
      TweenLite.to( dot_trigger, 0, { opacity: '0', y: '20%' } )
    },
    createAnimationTimeline() {
      const { dot_left, dot_trigger, dot_ring, dot_right, SplittingText, ContinueButton, dot_wrong_right, dot_wrong_left, cross_left, cross_right, cross_right_path, cross_left_path } = this.$refs

      this.animateElementsIn = new TimelineLite( {
        paused: true,
        onComplete: () => {
          this.showContinue = true
        }
      } )

      this.animateElementsIn
        .add( () => { SplittingText.animateTextIn() }, 0.3 )
        .to( dot_trigger, 0.6, { opacity: 1, y: '0%', ease: Expo.easeOut }, 0 )
        .to( dot_left, 0.6, { opacity: 1, scale: 1, ease: Expo.easeOut }, 1 )
        .to( dot_right, 0.6, { opacity: 1, scale: 1, ease: Expo.easeOut }, 1.3 )
        .to( dot_ring, 0.6, { opacity: 1, scale: 0.75, ease: Expo.easeOut }, 1.6 )
        .to( dot_trigger, 0.6, { scale: 0, ease: Expo.easeOut }, 1.7 )
        .to( cross_left_path, 0.6, { strokeDashoffset: 0, ease: Expo.easeOut }, 1.75 )
        .to( cross_right_path, 0.6, { strokeDashoffset: 0, ease: Expo.easeOut }, 1.75 )
        .to( dot_ring, 0.6, { scale: 1, ease: Expo.easeOut }, 2.2 )
        .to( dot_wrong_left, 0.6, { x: '-15%', opacity: 0.5, ease: Expo.easeOut }, 2.2 )
        .to( dot_wrong_right, 0.6, { x: '15%', opacity: 0.5, ease: Expo.easeOut }, 2.2 )
    },
    animateElementsOut() {
      const { dot_wrong_left, dot_trigger, dot_ring, dot_wrong_right, SplittingText, ContinueButton } = this.$refs

      this.animateOut = new TimelineLite( {
        onComplete: () => {
          this.showContinue = false
          this.onDemoComplete()
        }
      } )

      this.animateOut
        .to( dot_ring, 0.6, { y: '-20%', opacity: 0, ease: Expo.easeOut }, 0 )
        .to( dot_wrong_left, 0.6, { y: '-20%', opacity: 0, ease: Expo.easeOut }, 0 )
        .to( dot_wrong_right, 0.6, { y: '-20%', opacity: 0, ease: Expo.easeOut }, 0 )
        .add( () => { SplittingText.animateTextOut() }, 0 )
        .add( () => { ContinueButton.animateElementsOut.play() }, 0 )
    },
    proceed() {
      this.showGetReady()
      this.animateElementsOut()
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .YellowDotDemo {

    z-index: -1;
    position: relative;

    height: 0px;

    &.active {

      z-index: 2;

    }

    .ContinueButton {

      margin-top: rem( 100 );

      @include breakpoint( mobile-all ) {

        margin-top: rem( 40 );

      }

    }

    .dotDemo {

      .dot_wrong {

        position: relative;
      }

      .cross {
        position: absolute;
        top: 0;
        left: 0;

        display: block;

        stroke-width: rem( 2 );
        stroke: red;
        stroke-miterlimit: 10;
      }

      .crossPath {

        transform-origin: 50% 50%;

        stroke-dasharray: 29;
        stroke-dashoffset: 29;

      }

      .dots {

        display: flex;
        justify-content: center;

        margin: rem( 40 ) 0;

        @include breakpoint( mobile-all ) {

          margin: rem( 40 ) 0;

        }

        .dotwrong,
        .dot_wrong {

          img {

            width: rem( 85 );
            height: rem( 85 );
            max-width: 100%;

            @include breakpoint( mobile-all ) {

              width: rem( 65 );
              height: rem( 65 );

            }

          }

        }

        .dot_center {

          position: relative;

          padding: 0 rem( 100 );

          @include breakpoint( mobile-all ) {

            width: rem( 100 );
            height: rem( 100 );

            padding: 0 rem( 70 );

          }

          // & > div,
          & > img {

            position: absolute;
            left: 0;
            right: 0;
            top: -15%;

            width: rem( 120 );
            height: rem( 120 );

            margin: 0 auto;

            display: flex;
            justify-content: center;
            align-items: center;


            @include breakpoint( mobile-all ) {

              width: rem( 100 );
              height: rem( 100 );

            }

          }

        }

      }

    }

    h5 {

      @include lowecaseText();

      max-width: rem( 400 );
      width: 85%;
      margin: rem( 40 ) auto 0;

      @include breakpoint( mobile-all ) {

        margin: rem( 20 ) auto 0;

      }
    }

  }

</style>

<style lang="scss">

@import '@/styles/core.scss';

.YellowDotDemo {

  .dot_center > div {

    width: rem( 180 );
    // height: rem( 225 );

    @include breakpoint( tablet ) {

      width: 50%;

    }

    @include breakpoint( mobile-all ) {

      width: 50%;

    }

    position: absolute;
    left: 0;
    right: 0;
    top: 0;

    margin: 0 auto;

    display: flex;
    justify-content: center;
    align-items: center;

  }
}
</style>
